<template>
  <v-card v-if="isAuthenticated" class="mx-auto" max-width="350">
    <v-card-text class="text-center">
      <v-list-item-avatar size="200">
        <v-img v-if="photoURL" :src="photoURL"></v-img>
      </v-list-item-avatar>
      <v-file-input
        ref="fileInput"
        v-model="avatarFile"
        :rules="[
          value =>
            !value ||
            value.size < 500000 ||
            'Avatar size should be less than 0.5 MB!'
        ]"
        accept="image/*"
        prepend-icon="mdi-camera"
        label="Avatar image"
      ></v-file-input>

      <v-form id="login" v-model="formValid">
        <v-text-field
          v-model="username"
          :rules="[rules.required, checkUsername(username) || 'this username is used!']"
          label="Display Name"
          clearable
          autocomplete="username"
          @change="checkUsername(username)"
        ></v-text-field>
        <v-text-field
          v-model="email"
          :rules="[rules.required]"
          label="E-mail"
          data-vv-name="email"
          autocomplete="email"
          required
          clearable
          disabled
        ></v-text-field>
        <v-text-field
          v-model="password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          placeholder="New Password"
          hint="At least 8 characters"
          counter
          autocomplete="new-password"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
      </v-form>
      <br />
      <div v-if="error">
        <v-alert type="error">{{ error }}</v-alert>
      </div>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn
        color="primary"
        text
        :loading="loading"
        :disabled="loading || !formValid"
        block
        outlined
        @click="onUpdate"
      >Update</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { USER } from "@/store/actions.type";

export default {
  name: "UserUpdate",
  data: function() {
    return {
      email: null,
      password: null,
      username: null,
      photoURL: null,
      avatarFile: null,

      showPassword: false,
      formValid: false,
      loading: false,
      error: null,
      validUsername: false,
      rules: {
        required: value => !!value || "Required.",
        min: v => !!v && v.length <= 20
      }
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "currentUser"])
    // ...mapState({
    //   errors: state => state.auth.errors,
    //   currentUser: state => state.auth.user,
    //   isAuthenticated: state => state.auth.isAuthenticated
    // })
  },
  watch: {
    currentUser(v) {
      this.username = v.username;
      this.email = v.email;
      this.photoURL = v.photoURL;
    }
  },
  mounted() {
    if (this.currentUser) {
      this.username = this.currentUser.username;
      this.email = this.currentUser.email;
      this.photoURL = this.currentUser.photoURL;
    }
  },

  methods: {
    checkUsername(username) {
      if (username == null) {
        return false;
      } else if (username == this.currentUser.username) {
        return true;
      } else {
        this.$store.dispatch(USER.ISVALID_USERNAME, username).then(isValid => {
          this.validUsername = isValid;
        });
        return this.validUsername;
      }
    },
    async onUpdate() {
      this.loading = true;
      if (this.avatarFile) {
        var payload = {
          userId: this.currentUser.uid,
          avatarFile: this.avatarFile
        };

        await this.$store
          .dispatch(USER.UPLOAD_AVATAR, payload)
          .then(avatarURL => {
            this.photoURL = avatarURL;
          })
          .catch(e => {
            this.error = e.message;
            this.loading = false;
          });
      }
      var cred = {
        email: this.email,
        password: this.password,
        photoURL: this.photoURL,
        username: this.username
      };
      this.$store
        .dispatch(USER.UPDATE, cred)
        .then(() => {
          this.loading = false;
          // this.$router.push(this.$route.query.redirect || "/");
        })
        .catch(e => {
          // console.log(e);
          this.error = e.message;
          this.loading = false;
        });
    }
  }
};
</script>
